import { Entity } from '@/settings/domain/entity/entity/Entity';
import { Seal } from '../preRegister/Seal';

export class BillOfLanding {
  serial: string;
  sealList: Seal[];
  sender: Entity | null;
  recipient: Entity | null;
  transportistName: string;
  transportistId: string;
  deliveryName: Entity | null;
  licensePlate: string;
  notes: string;
  createdAt: string;
  updatedAt: string;
  active: boolean;
  date: string;

  public constructor() {
    this.serial = '';
    this.sealList = [];
    this.sender = null;
    this.recipient = null;
    this.transportistName = '';
    this.transportistId = '';
    this.deliveryName = null;
    this.licensePlate = '';
    this.notes = '';
    this.createdAt = '';
    this.updatedAt = '';
    this.active = true;
    this.date = '';
  }
}
